import { PMCountCategoriesCard } from "@pimo/pimo-components/src/lib/pm-components";

import { getDropdownCount } from "../../../utils/dropdown-options";
import { isFieldEnabled } from "../../field-enabled";
import { DashboardCardContext } from "../context";

export function addCountofProjectStatusCard(ctx: DashboardCardContext) {
  const { view, language, getCardCopy } = ctx;

  const countofProjectStatusComponent = view.addComponent({
    component: PMCountCategoriesCard,
    layoutProps: {
      componentId: "countofProjectStatusComponent",
      labels: ["status", "count"],
      description: getCardCopy(language, "projectStatusCounts").description,
      title: getCardCopy(language, "projectStatusCounts").title,
    },
  });

  countofProjectStatusComponent.mapLayoutProps(({ language }) => {
    return {
      componentId: "countofProjectStatusComponent",
      labels: ["status", "count"],
      title: getCardCopy(language, "projectStatusCounts").title,
      description: getCardCopy(language, "projectStatusCounts").description,
    };
  });

  countofProjectStatusComponent.mapState(
    ({ dashboard, settings, language }) => {
      const statusCounts = dashboard?._calculated?.projectStatusCounts ?? {};
      const data = (settings?.configuration?.statusDefinition ?? []).map(
        (entry) => {
          return {
            label: entry.name ?? "",
            count: getDropdownCount(statusCounts, entry),
            color: entry.color ?? "",
          };
        }
      );

      return {
        title: getCardCopy(language, "projectStatusCounts").title,
        data,
        showInfoIcon: false,
        showMenuIcon: false,
      };
    }
  );

  countofProjectStatusComponent.mapVisibility(({ settings }) =>
    isFieldEnabled(settings, "status", "itemReporting")
  );
}
